var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrap synergeticOffice clearfix"},[_c('div',{staticClass:"clearfix content_boox"},[_c('pro-channel'),_vm._v(" "),_c('travel-line'),_vm._v(" "),_c('tourists'),_vm._v(" "),_c('visitor-ratio'),_vm._v(" "),_c('visitor-age'),_vm._v(" "),_c('consumption')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c6dc09e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketing/marketing.vue
// module id = null
// module chunks = 